// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForInteraction } from '@atlassian/react-async';

export const legacyPageEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-legacy-page-entrypoint" */ './index.tsx'),
	),
	getPreloadProps: () => ({}),
});
